import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { memo } from "react";
import { ASSET_MODAL_CLOSE } from "~/constants/testIDs";
export const CloseButton = /*#__PURE__*/ memo((param)=>{
    let { onClose } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center justify-start",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "mx-4 h-6 w-px rounded-2 bg-grey-5"
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                appearance: "ghost",
                color: "grey",
                "data-testid": ASSET_MODAL_CLOSE,
                icon: Close,
                label: "Close",
                onClick: onClose,
                size: "medium"
            })
        ]
    });
});
CloseButton.displayName = "CloseButton";
